module.exports = __webpack_public_path__ + "static/img/loginBg.26e0973.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/loginBg.png
// module id = 0uYR
// module chunks = 22